var isMobile = require('ismobilejs');
var $ = require('jquery');

var DEFAULTS = {
	selector: 'span.phone-number',
	linkClassName: 'phone-number',
	domChange: true
};

/**
 * Detect phone numbers by given selector and transform them into anchors when viewed on Cell phone
 * @param element
 * @param options
 * @constructor
 */
var PhoneLinkActivation = function ( element, options ) {
	this.element = element;
	this.$t = $(this.element);

	this.options = $.extend(true, {}, DEFAULTS, options );
	this._defaults = DEFAULTS;

	this.observer = null;

	this._initialise();
};

/**
 * init function, detect and run, if needed
 * @private
 */
PhoneLinkActivation.prototype._initialise = function() {
	/**
	 * init mobile detection
	 */
	this.isMobile = isMobile;

	/**
	 * we really don't need it, if we don't have a phone
	 */
	if (!this.isMobile.phone) {
		return false;
	}

	/**
	 * get all unprocessed phone number elements and process them
	 */
	this.getRelevantElements();

	/**
	 * start MutationObserver()
	 * browsers not supporting MutationObserver we can ignore
	 */
	if (this.options.domChange) {
		this._initMutationObserver();
	}
};

/**
 * init DOM changes detection for most modern browsers
 * @private
 */
PhoneLinkActivation.prototype._initMutationObserver = function() {
	var _self = this;

	// FF, Chrome, Safari, iOS, Android, IE11+
	if (window.MutationObserver) {
		this.observer = new MutationObserver(function(mutations, observer) {
			_self.getRelevantElements();
		});

		this.observer.observe(_self.element, {
			childList: true,
			subtree: true
		});
	}
};

/**
 * the only public method, gets elements according to the selector in options and send them to be processed
 */
PhoneLinkActivation.prototype.getRelevantElements = function() {
	this.elements = [];
	this.elements = $(this.options.selector);

	this._processPhoneNumbers();
};

/**
 * iterates through the collected elements, marks them not to be processed twice and calls transformation to anchor
 * @private
 */
PhoneLinkActivation.prototype._processPhoneNumbers = function() {
	var _self = this;

	$.each(this.elements, function(index, item) {
		/**
		 * proces only non-flagged spans - to be sure not to add anchor twice in a row (due to MutationObserver)
		 */
		if (!$(item).data('PhoneLinkActivationApplied')) {
			_self._changePhoneElementToAnchor($(item));
		}
	});
};

/**
 * transforms $phoneNumberElement into an anchor with tel:
 * @param $phoneNumberElement
 * @private
 */
PhoneLinkActivation.prototype._changePhoneElementToAnchor = function($phoneNumberElement) {
	$phoneNumberElement.data('PhoneLinkActivationApplied', '1');

	var phoneNumber = $phoneNumberElement.text();
	$phoneNumberElement.after('<a class="' + this.options.linkClassName + '" href="tel:' + phoneNumber.replace(/\s/gi, '') + '">' + phoneNumber + '</a>');
	$phoneNumberElement.remove();
};

module.exports = PhoneLinkActivation;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/phoneLinkActivation.js